import { Link } from "react-router-dom";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

const LINK_CLASSES =
  "tw:block tw:truncate tw:text-muted-foreground! tw:hover:text-foreground!";

const Crumb = ({ to, label }) => (
  <>
    <BreadcrumbItem className="tw:min-w-0">
      <BreadcrumbLink className={LINK_CLASSES} render={<Link to={to} />}>
        {label}
      </BreadcrumbLink>
    </BreadcrumbItem>
    <BreadcrumbSeparator className="tw:[&>svg]:size-3" />
  </>
);

// Breadcrumb for a record page: the parent list, any `trail` of linked levels
// below it (such as the record on its edit page), and the current page.
export function DetailBreadcrumb({
  parentTo,
  parentLabel,
  trail = [],
  current,
}) {
  return (
    <Breadcrumb>
      <BreadcrumbList className="tw:flex-nowrap tw:text-xs">
        <Crumb to={parentTo} label={parentLabel} />
        {trail.map(item => (
          <Crumb key={item.to} to={item.to} label={item.label} />
        ))}
        <BreadcrumbItem className="tw:min-w-0">
          <BreadcrumbPage className="tw:block tw:truncate tw:font-semibold tw:text-foreground">
            {current}
          </BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
}
